angular.module('components.caPurchaseOrderExtraOptions', [])
    .component('caPurchaseOrderExtraOptions', {
        templateUrl: 'main/order/purchaseorder/components/purchaseorderextraoptions.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            purchaseOrder: '<',
            disabled: '<',
            orderChangeCount: '<',
            selectedArticle: '<'
        },
        controller: controller
    });

// @ngInject
function controller(loadSpinnerService, StockLogisticsApiService, ToasterService) {
    var vm = this;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;

    vm.showExtraOptions = false;
    vm.stockLogisticsHasBeenCreated = false;

    vm.toggleExtraOptionsVisibility = toggleExtraOptionsVisibility;
    vm.createStockLogistics = createStockLogistics;

    function onInit() {
    }

    function onChanges() {
    }

    function onDestroy() {
    }

    function toggleExtraOptionsVisibility() {
        vm.showExtraOptions = !vm.showExtraOptions;
    }

        // Use the current quantity data to create or update stock logistics of the current article.
    function createStockLogistics() {
        var stockLogistics = [];

        loadSpinnerService.start('mainSpinner');
        StockLogisticsApiService.getByArticle(vm.selectedArticle.id).then(function(getResponse) {

            var oldStockLogistics = getResponse.data;

            _.forEach(oldStockLogistics, function(stlog) {
                stockLogistics.push(stlog);
            });

            _.forEach(vm.purchaseOrder.orders, function(order) {
                _.forEach(order.orderArticles, function(orderArticle) {
                    if (orderArticle.article.id === vm.selectedArticle.id) {
                        _.forEach(orderArticle.orderRows, function(orderRow) {
                            var stockLogistic = _.find(stockLogistics, function(stLog) {
                                return stLog.articleVariant.id === orderRow.articleVariant.id && stLog.location.id === order.destination.id;
                            });

                            if (orderRow.quantity === 0) {
                                return;
                            }

                            if (!stockLogistic) {
                                stockLogistic = newEmptyStockLogistic();
                                stockLogistic.location = order.destination;
                                stockLogistic.articleVariant = orderRow.articleVariant;
                                stockLogistics.push(stockLogistic);
                            }
                            stockLogistic.orderingPointMax = orderRow.quantity;
                        });
                    }
                });
            });

            StockLogisticsApiService.saveStockLogistics(stockLogistics).then(function(response) {
                vm.stockLogisticsHasBeenCreated = true;
            }, function(postError) {
                console.log(postError);
                ToasterService.showError(postError.message);
            });

        }, function(getError) {
            console.log(getError);
            ToasterService.showError(getError.message);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });

    }

    function newEmptyStockLogistic() {
        return {
            id: 0,
            location: {},
            articlevariant: {},
            orderingPointMin: 0,
            orderingPointMax: 0,
            packSize: 0,
            quantityInTransit: 0,
            monday: false,
            tuesday: false,
            wednesday: false,
            thursday: false,
            friday: false,
            saturday: false,
            sunday: false
        };
    }

    // Get all unique variantDetail2s from provided article
    function getSizeVariants(article) {
        var sizeVariants = [];
        _.forEach(article.articleVariants, function(articleVariant) {
            if (!_.find(sizeVariants, {id: articleVariant.variantDetail2.id})) {
                sizeVariants.push(articleVariant.variantDetail2);
            }
        });

        return _.sortBy(sizeVariants, 'sortOrder');
    }

    // Get all unique variantDetail1s from provided article
    function getColorVariants(article) {
        var colorVariants = [];
        _.forEach(article.articleVariants, function(articleVariant) {
            if (!_.find(colorVariants, {id: articleVariant.variantDetail1.id})) {
                colorVariants.push(articleVariant.variantDetail1);
            }
        });

        return _.sortBy(colorVariants, 'sortOrder');
    }
}
